<template lang="pug">
  #events
    homeNav
    
    div.events
      layout-container
        h1(style="margin-top: 1.5rem").title Flipped Classroom
        .event(v-for="classroom, index in $store.state.classroom.classroom" :to="'/flippedclassroom/' + classroom.id" :key="classroom.id")
          div.event__banner(:style="{backgroundImage: 'url(' + classroom.cover + ')'}")
          div.event__contents
            p.feedPost__subtitle.unsetNodes(v-html="classroom.description")
            button.feedPost__date.classroom__button.--primary
              p #[a(:href="classroom.link" target="_blank") Join Classroom]

</template>

<style lang="sass" scoped>
@import '../assets/style'

.title    
  color: #00b8e6
  text-shadow: 1px 1px #b3b3cc

.eventsHeader
  background-color: $color-primary
  color: $color-against-primary

.eventsNav
  display: flex
  align-items: center
  justify-content: space-between
  height: 4rem

.event__title
  font-weight: lighter
  margin-bottom: 1.5rem
  color: #00b8e6
  text-shadow: 1px 1px #b3b3cc
  

.eventsNav__action
  padding: 1rem
  @include actionable-primary
  display: flex
  align-items: center
  justify-content: center
  border-radius: 3rem
  height: 3rem
  margin: 0.5rem
  text-decoration: none
  color: inherit

.eventsNav__action--small
  width: 3rem



.event
  border-radius: 0.5rem
  background-color: $color-background-light
  margin: $pad 0
  border: 1px solid $color-layout-border
  overflow: hidden
  display: grid
  grid-template-columns: 1fr
  cursor: pointer
  text-decoration: none
  color: inherit

  @include from($tablet-portrait)
    grid-template-columns: 1fr 1fr




.event__banner
  width: 100%
  background-color: #ddd
  background-size: cover
  background-position: center

  height: 100vw
  @include from($tablet-portrait)
    height: 23rem

.feedPost__subtitle
  color: #555
  font-size: 12pt

.feedPost__date
  margin-top: 2rem
  font-weight: normal
  color: $color-primary

.event__contents
  padding: $pad
  border-right: 10px solid #00b8e6
  box-shadow: 5px 20px #b3b3cc

.classroom__button
  color: white

.classroom__button a:link
  color: white

.classroom__button a:visited
  color: white

.classroom__button a:hover
  color: white

</style>



<script>
import layoutContainer from '@/components/layoutContainer'
import homeNav from '@/components/homeNav'
export default {
  name: 'events',
  components: {
    layoutContainer,
    homeNav
  },
  mounted() {
    window.scrollTo(0, 0);
    this.$store.dispatch('loadClassroom');
  }
}
</script>